"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.emitted = exports.processingEmission = exports.pendingEmission = exports.pendingInspection = exports.withVehicleRCPackProduct = exports.withVehicleRCProduct = exports.withVehicleProduct = exports.withAllPossibleCoverages = exports.withoutCoverages = exports.withoutUnits = exports.regular = void 0;
var Quotation_1 = require("../models/Quotation");
var mockCustomer_1 = __importDefault(require("./mockCustomer"));
var mockUnits = __importStar(require("./mockUnits"));
var mockSummaries = __importStar(require("./mockQuotationSummaries"));
var mockQuotationStatus = __importStar(require("./mockQuotationStatus"));
var products_1 = require("../constants/products");
/**
 * The base quotation variant
 */
exports.regular = __assign(__assign({}, Quotation_1.makeEmptyQuotation()), { code: 'foo', urlSalt: 'foo-url-salt', units: [mockUnits.regular], customer: mockCustomer_1.default });
/**
 * Possible unit configurations
 */
exports.withoutUnits = __assign(__assign({}, exports.regular), { units: [] });
exports.withoutCoverages = __assign(__assign({}, exports.regular), { units: [mockUnits.withoutCoverages] });
/**
 * This quotation has the following coverage properties:
 * - 6 total coverages
 * - 5 of them are of type "coverage"
 * - 1 of them is of type "endorsement"
 * - deductible only applies to 2 of them.
 *
 * This means that the data integrity between this definition and `mockCoverageCatalogResumeList` must
 * be ensured at all times.
 */
exports.withAllPossibleCoverages = __assign(__assign({}, exports.regular), { units: [mockUnits.withAllPossibleCoverages] });
/**
 * Possible product configurations
 */
exports.withVehicleProduct = __assign(__assign({}, exports.regular), { productId: products_1.COMPLETE_VEHICLE, summary: mockSummaries.withVehicleProduct });
exports.withVehicleRCProduct = __assign(__assign({}, exports.regular), { productId: products_1.THIRD_PARTY_VEHICLE, summary: mockSummaries.withVehicleRCProduct });
exports.withVehicleRCPackProduct = __assign(__assign({}, exports.regular), { productId: products_1.THIRD_PARTY_PACK, summary: mockSummaries.withVehicleRCPackProduct });
/**
 * Possible status configurations
 */
exports.pendingInspection = __assign(__assign({}, exports.regular), { status: mockQuotationStatus.pendingInspection, summary: mockSummaries.pendingInspection });
exports.pendingEmission = __assign(__assign({}, exports.regular), { status: mockQuotationStatus.pendingEmission, summary: mockSummaries.pendingEmission });
exports.processingEmission = __assign(__assign({}, exports.regular), { status: mockQuotationStatus.processingEmission, summary: mockSummaries.processsingEmission });
exports.emitted = __assign(__assign({}, exports.regular), { status: mockQuotationStatus.emitted, summary: mockSummaries.emitted });
//# sourceMappingURL=mockQuotations.js.map